module.exports = __webpack_public_path__ + "static/media/1.5434f27c.png";